var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"d16bb56f8330f281007e12c832ce5389ef9847e4"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["cube-front@rac"]={id:"d16bb56f8330f281007e12c832ce5389ef9847e4"};
      